/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContractorTypeOption,
  ContractorTypeOptionRequest,
  PaginatedContractorTypeOptionList,
  PatchedContractorTypeOptionRequest,
  ProContractorTypeListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getProContractorTypeListUrl = (params?: ProContractorTypeListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pro-contractor-type/?${stringifiedParams}` : `/api/pro-contractor-type/`
}

/**
 * Pro contractor type represents pro's work preferences ('gigs', 'part-time', 'full-time', etc.)
 */
export const proContractorTypeList = async (params?: ProContractorTypeListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedContractorTypeOptionList> => {

  return customFetch<PaginatedContractorTypeOptionList>(getProContractorTypeListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProContractorTypeListInfiniteQueryKey = (params?: ProContractorTypeListParams,) => {
    return [
    'infinite', `/api/pro-contractor-type/`, ...(params ? [params] : [])
    ] as const;
    }

export const getProContractorTypeListQueryKey = (params?: ProContractorTypeListParams,) => {
    return [
    `/api/pro-contractor-type/`, ...(params ? [params] : [])
    ] as const;
    }


export const getProContractorTypeListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof proContractorTypeList>>, ProContractorTypeListParams['page']>, TError = void>(params?: ProContractorTypeListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData, QueryKey, ProContractorTypeListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProContractorTypeListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proContractorTypeList>>, QueryKey, ProContractorTypeListParams['page']> = ({ signal, pageParam }) => proContractorTypeList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData, QueryKey, ProContractorTypeListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProContractorTypeListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof proContractorTypeList>>>
export type ProContractorTypeListInfiniteQueryError = void


export function useProContractorTypeListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof proContractorTypeList>>, ProContractorTypeListParams['page']>, TError = void>(
 params: undefined |  ProContractorTypeListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData, QueryKey, ProContractorTypeListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proContractorTypeList>>,
          TError,
          Awaited<ReturnType<typeof proContractorTypeList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProContractorTypeListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof proContractorTypeList>>, ProContractorTypeListParams['page']>, TError = void>(
 params?: ProContractorTypeListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData, QueryKey, ProContractorTypeListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proContractorTypeList>>,
          TError,
          Awaited<ReturnType<typeof proContractorTypeList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProContractorTypeListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof proContractorTypeList>>, ProContractorTypeListParams['page']>, TError = void>(
 params?: ProContractorTypeListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData, QueryKey, ProContractorTypeListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProContractorTypeListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof proContractorTypeList>>, ProContractorTypeListParams['page']>, TError = void>(
 params?: ProContractorTypeListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData, QueryKey, ProContractorTypeListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProContractorTypeListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProContractorTypeListQueryOptions = <TData = Awaited<ReturnType<typeof proContractorTypeList>>, TError = void>(params?: ProContractorTypeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProContractorTypeListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proContractorTypeList>>> = ({ signal }) => proContractorTypeList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProContractorTypeListQueryResult = NonNullable<Awaited<ReturnType<typeof proContractorTypeList>>>
export type ProContractorTypeListQueryError = void


export function useProContractorTypeList<TData = Awaited<ReturnType<typeof proContractorTypeList>>, TError = void>(
 params: undefined |  ProContractorTypeListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proContractorTypeList>>,
          TError,
          Awaited<ReturnType<typeof proContractorTypeList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProContractorTypeList<TData = Awaited<ReturnType<typeof proContractorTypeList>>, TError = void>(
 params?: ProContractorTypeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proContractorTypeList>>,
          TError,
          Awaited<ReturnType<typeof proContractorTypeList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProContractorTypeList<TData = Awaited<ReturnType<typeof proContractorTypeList>>, TError = void>(
 params?: ProContractorTypeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProContractorTypeList<TData = Awaited<ReturnType<typeof proContractorTypeList>>, TError = void>(
 params?: ProContractorTypeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProContractorTypeListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProContractorTypeCreateUrl = () => {




  return `/api/pro-contractor-type/`
}

/**
 * Pro contractor type represents pro's work preferences ('gigs', 'part-time', 'full-time', etc.)
 */
export const proContractorTypeCreate = async (contractorTypeOptionRequest: ContractorTypeOptionRequest, options?: Parameters<typeof customFetch>[1]): Promise<ContractorTypeOption> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ContractorTypeOption>(getProContractorTypeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(contractorTypeOptionRequest)
  }
);}





export const getProContractorTypeCreateMutationKey = () => ['proContractorTypeCreate'] as const;

export const getProContractorTypeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proContractorTypeCreate>>, TError,ProContractorTypeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proContractorTypeCreate>>, TError,ProContractorTypeCreateMutationVariables, TContext> => {

const mutationKey = getProContractorTypeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proContractorTypeCreate>>, ProContractorTypeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  proContractorTypeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProContractorTypeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proContractorTypeCreate>>>
    export type ProContractorTypeCreateMutationBody = ContractorTypeOptionRequest
    export type ProContractorTypeCreateMutationError = void
    export type ProContractorTypeCreateMutationVariables = {data: ContractorTypeOptionRequest}

    export const useProContractorTypeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proContractorTypeCreate>>, TError,ProContractorTypeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proContractorTypeCreate>>,
        TError,
        ProContractorTypeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProContractorTypeCreateMutationOptions(options), queryClient);
    }
    export const getProContractorTypeRetrieveUrl = (id: number,) => {




  return `/api/pro-contractor-type/${id}/`
}

/**
 * Pro contractor type represents pro's work preferences ('gigs', 'part-time', 'full-time', etc.)
 */
export const proContractorTypeRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ContractorTypeOption> => {

  return customFetch<ContractorTypeOption>(getProContractorTypeRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProContractorTypeRetrieveQueryKey = (id: number,) => {
    return [
    `/api/pro-contractor-type/${id}/`
    ] as const;
    }


export const getProContractorTypeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProContractorTypeRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proContractorTypeRetrieve>>> = ({ signal }) => proContractorTypeRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProContractorTypeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof proContractorTypeRetrieve>>>
export type ProContractorTypeRetrieveQueryError = void


export function useProContractorTypeRetrieve<TData = Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proContractorTypeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proContractorTypeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProContractorTypeRetrieve<TData = Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proContractorTypeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proContractorTypeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProContractorTypeRetrieve<TData = Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProContractorTypeRetrieve<TData = Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proContractorTypeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProContractorTypeRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProContractorTypeUpdateUrl = (id: number,) => {




  return `/api/pro-contractor-type/${id}/`
}

/**
 * Pro contractor type represents pro's work preferences ('gigs', 'part-time', 'full-time', etc.)
 */
export const proContractorTypeUpdate = async (id: number,
    contractorTypeOptionRequest: ContractorTypeOptionRequest, options?: Parameters<typeof customFetch>[1]): Promise<ContractorTypeOption> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ContractorTypeOption>(getProContractorTypeUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(contractorTypeOptionRequest)
  }
);}





export const getProContractorTypeUpdateMutationKey = () => ['proContractorTypeUpdate'] as const;

export const getProContractorTypeUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proContractorTypeUpdate>>, TError,ProContractorTypeUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proContractorTypeUpdate>>, TError,ProContractorTypeUpdateMutationVariables, TContext> => {

const mutationKey = getProContractorTypeUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proContractorTypeUpdate>>, ProContractorTypeUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proContractorTypeUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProContractorTypeUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proContractorTypeUpdate>>>
    export type ProContractorTypeUpdateMutationBody = ContractorTypeOptionRequest
    export type ProContractorTypeUpdateMutationError = void
    export type ProContractorTypeUpdateMutationVariables = {id: number;data: ContractorTypeOptionRequest}

    export const useProContractorTypeUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proContractorTypeUpdate>>, TError,ProContractorTypeUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proContractorTypeUpdate>>,
        TError,
        ProContractorTypeUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProContractorTypeUpdateMutationOptions(options), queryClient);
    }
    export const getProContractorTypePartialUpdateUrl = (id: number,) => {




  return `/api/pro-contractor-type/${id}/`
}

/**
 * Pro contractor type represents pro's work preferences ('gigs', 'part-time', 'full-time', etc.)
 */
export const proContractorTypePartialUpdate = async (id: number,
    patchedContractorTypeOptionRequest?: PatchedContractorTypeOptionRequest, options?: Parameters<typeof customFetch>[1]): Promise<ContractorTypeOption> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ContractorTypeOption>(getProContractorTypePartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedContractorTypeOptionRequest)
  }
);}





export const getProContractorTypePartialUpdateMutationKey = () => ['proContractorTypePartialUpdate'] as const;

export const getProContractorTypePartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proContractorTypePartialUpdate>>, TError,ProContractorTypePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proContractorTypePartialUpdate>>, TError,ProContractorTypePartialUpdateMutationVariables, TContext> => {

const mutationKey = getProContractorTypePartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proContractorTypePartialUpdate>>, ProContractorTypePartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proContractorTypePartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProContractorTypePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proContractorTypePartialUpdate>>>
    export type ProContractorTypePartialUpdateMutationBody = PatchedContractorTypeOptionRequest | undefined
    export type ProContractorTypePartialUpdateMutationError = void
    export type ProContractorTypePartialUpdateMutationVariables = {id: number;data?: PatchedContractorTypeOptionRequest}

    export const useProContractorTypePartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proContractorTypePartialUpdate>>, TError,ProContractorTypePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proContractorTypePartialUpdate>>,
        TError,
        ProContractorTypePartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProContractorTypePartialUpdateMutationOptions(options), queryClient);
    }
